/* FW_META_ATTRIBUTION_CAPTURE_V3_SCRIPTTAG: Shopify ScriptTag capture for Meta offline attribution */
(function(){
  if (window.__FW_META_ATTRIBUTION_CAPTURE_V3__) return;
  window.__FW_META_ATTRIBUTION_CAPTURE_V3__ = true;
  try {
    var params = new URLSearchParams(window.location.search || '');
    var fbclid = params.get('fbclid') || '';
    var now = Math.floor(Date.now()/1000);
    function esc(s){return s.replace(/([.$?*|{}()\[\]\\\/\+^])/g,'\\$1');}
    function getCookie(n){var m=document.cookie.match(new RegExp('(?:^|; )'+esc(n)+'=([^;]*)'));return m?decodeURIComponent(m[1]):'';}
    function setCookie(n,v){if(v) document.cookie=n+'='+encodeURIComponent(v)+'; path=/; max-age=7776000; SameSite=Lax';}
    var fbp=getCookie('_fbp');
    if(!fbp){fbp='fb.1.'+Date.now()+'.'+Math.floor(Math.random()*1000000000);setCookie('_fbp',fbp);}
    var fbc=getCookie('_fbc');
    if(fbclid&&!fbc){fbc='fb.1.'+now+'.'+fbclid;setCookie('_fbc',fbc);}
    var attrs={attributes:{}};
    function putAttr(k,v){if(typeof v==='string'&&v!==''){attrs.attributes[k]=v;}}
    putAttr('_fbp',fbp);putAttr('_fbc',fbc);putAttr('fbclid',fbclid);putAttr('utm_source',params.get('utm_source'));putAttr('utm_medium',params.get('utm_medium'));putAttr('utm_campaign',params.get('utm_campaign'));
    if(Object.keys(attrs.attributes).length){
      attrs.attributes.fw_meta_attr_version='v3_scripttag';
      var payload=JSON.stringify(attrs);
      if(navigator.sendBeacon) navigator.sendBeacon('/cart/update.js', new Blob([payload],{type:'application/json'}));
      else fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:payload,keepalive:true,credentials:'same-origin'}).catch(function(){});
    }
  } catch(e) {}
})();
